module.exports = {
  schema: {
    name: '價格表',
    type: 'Object',
    contents: {
      key: {
        type: 'String',
        name: '價格表名稱',
      },
      brandRef: {
        name: '品牌',
        type: 'ObjectId',
        reference: 'brands',
        refKeys: ['key', 'name'],
      },
      customerGroupRefs: {
        name: '客戶群',
        type: 'Array',
        input: 'select',
        multi: true,
        contents: [{
          type: 'ObjectId',
          reference: 'customerGroups',
          refKeys: ['key'],
        }],
      },
      timeStart: {
        type: 'Date',
        name: '開始時間',
        format: 'YYYY/MM/DD',
      },
      timeEnd: {
        type: 'Date',
        name: '結束時間',
        format: 'YYYY/MM/DD',
      },
      type: {
        name: '類型',
        type: 'String',
        options: ['合約價', '牌價', '活動價', '上傳價'],
        input: 'select',
      },
      description: {
        type: 'String',
        name: '價格邏輯',
        input: 'textarea',
      },
      priority: {
        type: 'Number',
        name: '順序',
      },
      taxAdded: {
        type: 'Boolean',
        name: '含稅',
      },
    },
  },
  index: {
    primary: {
      key: {
        key: 1,
      },
      unique: true,
    },
  },
  ui: {
    list: {
      columns: [
        { key: 'key', width: 200 },
        { key: 'brandRef', width: 120 },
        { key: 'customerGroupRefs' },
        { key: 'timeStart', width: 120 },
        { key: 'timeEnd', width: 120 },
        { key: 'type', width: 80 },
        { key: 'description', width: 150 },
        { key: 'priority', width: 60 },
        { key: 'taxAdded' },
      ],
    },
    editor: {
      groups: [
        {
          name: '',
          rows: [
            [{ key: 'key' }],
            [{ key: 'brandRef' }, { key: 'customerGroupRefs' }],
            [{ key: 'timeStart' }, { key: 'timeEnd' }],
            [{ key: 'priority' }, { key: 'taxAdded' }],
            [{ key: 'type' }, { key: 'description' }],
          ],
        },
      ],
    },
  },
}



// WEBPACK FOOTER //
// ./src/models/pricebooks.js